import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { ChartFeature, CircleLayerSpecification } from '../chart-props';

export function drawCircleLayer(pass: DrawPass, features: ChartFeature[], layer: CircleLayerSpecification, xAxis: Axis, yAxis: Axis) {
    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        if (feature.geometry.type === 'Point') {
            const color = typeof layer.paint.color === 'function' ? layer.paint.color(feature) : layer.paint.color;
            const p = [
                xAxis.project(feature.geometry.coordinates[0], pass.viewState),
                yAxis.project(feature.geometry.coordinates[1], pass.viewState)
            ] as [number, number];
            if (layer.paint.hollow) {
                pass.drawer.drawHollowCircle(p, layer.paint.radius ?? 1, { color });
            } else {
                pass.drawer.drawCircle(p, layer.paint.radius ?? 1, { color });
            }
        }
    }
}
